/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Recentchangestitle2Inputs */

const id_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan terbaru`)
};

const ms_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perubahan terkini`)
};

const da_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste ændringer`)
};

const de_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Änderungen`)
};

const en_us2_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent changes`)
};

const es_es2_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios recientes`)
};

const es_mx2_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios recientes`)
};

const fil_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga kamakailang pagbabago`)
};

const fr_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications récentes`)
};

const it_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche recenti`)
};

const hu_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbbi változások`)
};

const nl_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente wijzigingen`)
};

const no_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nylige endringer`)
};

const pl_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie zmiany`)
};

const pt_br2_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mudanças recentes`)
};

const pt_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações recentes`)
};

const ro_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modificări recente`)
};

const fi_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät muutokset`)
};

const sv_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste ändringarna`)
};

const vi_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi gần đây`)
};

const tr_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son değişiklikler`)
};

const cs_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedávné změny`)
};

const bg_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорошни промени`)
};

const ru_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние изменения`)
};

const uk_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні зміни`)
};

const ar_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التغييرات الأخيرة`)
};

const hi_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल के परिवर्तन`)
};

const th_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การเปลี่ยนแปลงล่าสุด`)
};

const ja_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近の変更`)
};

const zh_cn2_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近更改`)
};

const zh_hant1_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近變更`)
};

const ko_sandboxes_recentchangestitle2 = /** @type {(inputs: Sandboxes_Recentchangestitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최근 변경 사항`)
};

/**
* | output |
* | --- |
* | "Recent changes" |
*
* @param {Sandboxes_Recentchangestitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_recentchangestitle2 = /** @type {((inputs?: Sandboxes_Recentchangestitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Recentchangestitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_recentchangestitle2(inputs)
	if (locale === "ms") return ms_sandboxes_recentchangestitle2(inputs)
	if (locale === "da") return da_sandboxes_recentchangestitle2(inputs)
	if (locale === "de") return de_sandboxes_recentchangestitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_recentchangestitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_recentchangestitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_recentchangestitle2(inputs)
	if (locale === "fil") return fil_sandboxes_recentchangestitle2(inputs)
	if (locale === "fr") return fr_sandboxes_recentchangestitle2(inputs)
	if (locale === "it") return it_sandboxes_recentchangestitle2(inputs)
	if (locale === "hu") return hu_sandboxes_recentchangestitle2(inputs)
	if (locale === "nl") return nl_sandboxes_recentchangestitle2(inputs)
	if (locale === "no") return no_sandboxes_recentchangestitle2(inputs)
	if (locale === "pl") return pl_sandboxes_recentchangestitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_recentchangestitle2(inputs)
	if (locale === "pt") return pt_sandboxes_recentchangestitle2(inputs)
	if (locale === "ro") return ro_sandboxes_recentchangestitle2(inputs)
	if (locale === "fi") return fi_sandboxes_recentchangestitle2(inputs)
	if (locale === "sv") return sv_sandboxes_recentchangestitle2(inputs)
	if (locale === "vi") return vi_sandboxes_recentchangestitle2(inputs)
	if (locale === "tr") return tr_sandboxes_recentchangestitle2(inputs)
	if (locale === "cs") return cs_sandboxes_recentchangestitle2(inputs)
	if (locale === "bg") return bg_sandboxes_recentchangestitle2(inputs)
	if (locale === "ru") return ru_sandboxes_recentchangestitle2(inputs)
	if (locale === "uk") return uk_sandboxes_recentchangestitle2(inputs)
	if (locale === "ar") return ar_sandboxes_recentchangestitle2(inputs)
	if (locale === "hi") return hi_sandboxes_recentchangestitle2(inputs)
	if (locale === "th") return th_sandboxes_recentchangestitle2(inputs)
	if (locale === "ja") return ja_sandboxes_recentchangestitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_recentchangestitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_recentchangestitle2(inputs)
	return ko_sandboxes_recentchangestitle2(inputs)
});
export { sandboxes_recentchangestitle2 as "sandboxes.recentChangesTitle" }